import { AI_MODELS_MODULE_ID, AI_MODELS_REGISTER_ID } from '../../ai-models/aiModelConstants';
import {
  GOVERNED_MCP_GATEWAY_ACTIVITY_ID,
  GOVERNED_MCP_GATEWAY_API_KEYS_ID,
  GOVERNED_MCP_GATEWAY_CONFIGURATION_ID,
  GOVERNED_MCP_GATEWAY_DASHBOARD_ID,
  GOVERNED_MCP_GATEWAY_MODULE_ID,
  GOVERNED_MCP_GATEWAY_PATHS,
  GOVERNED_MCP_GATEWAY_TOOLS_ID,
  MCP_ACCESS_MANAGER_MODULE_ID,
  MCP_RESOURCES_MODULE_ID,
} from '../../governed-mcp-gateway/governedMcpConstants';

export interface RoutePrivilege {
  id: string;
  uid: string;
  label: string;
  path: string | null;
  icon: string;
  hasAccess: boolean;
  children?: RoutePrivilege[];
}

const GOVERNED_MCP_GATEWAY_PAGES: RoutePrivilege[] = [
  {
    id: GOVERNED_MCP_GATEWAY_DASHBOARD_ID,
    uid: 'governed_mcp_gateway_dashboard',
    label: 'Dashboard',
    path: GOVERNED_MCP_GATEWAY_PATHS.dashboard,
    icon: 'LayoutDashboard',
    hasAccess: true,
  },
  {
    id: GOVERNED_MCP_GATEWAY_TOOLS_ID,
    uid: 'governed_mcp_gateway_tools',
    label: 'Tools',
    path: GOVERNED_MCP_GATEWAY_PATHS.tools,
    icon: 'Wrench',
    hasAccess: true,
  },
  {
    id: GOVERNED_MCP_GATEWAY_CONFIGURATION_ID,
    uid: 'governed_mcp_gateway_configuration',
    label: 'Configuration',
    path: GOVERNED_MCP_GATEWAY_PATHS.configuration,
    icon: 'Settings2',
    hasAccess: true,
  },
  {
    id: GOVERNED_MCP_GATEWAY_API_KEYS_ID,
    uid: 'governed_mcp_gateway_api_keys',
    label: 'AI Usage & Spendings',
    path: GOVERNED_MCP_GATEWAY_PATHS.aiUsage,
    icon: 'Gauge',
    hasAccess: true,
  },
];

const GOVERNED_MCP_GATEWAY_ACTIVITY_NODE: RoutePrivilege = {
  id: GOVERNED_MCP_GATEWAY_ACTIVITY_ID,
  uid: 'governed_mcp_gateway_activity',
  label: 'Activity',
  path: GOVERNED_MCP_GATEWAY_PATHS.dashboard,
  icon: 'Activity',
  hasAccess: true,
};

const GOVERNED_MCP_GATEWAY_MODULE_LEAF: RoutePrivilege = {
  id: GOVERNED_MCP_GATEWAY_MODULE_ID,
  uid: 'governed_mcp_gateway',
  label: 'MCP Gateway',
  path: GOVERNED_MCP_GATEWAY_PATHS.dashboard,
  icon: 'Network',
  hasAccess: true,
};

const GOVERNED_MCP_GATEWAY_NODE: RoutePrivilege = {
  ...GOVERNED_MCP_GATEWAY_MODULE_LEAF,
  children: [...GOVERNED_MCP_GATEWAY_PAGES, GOVERNED_MCP_GATEWAY_ACTIVITY_NODE],
};

export const mockRoutes = [
  {
    "id": "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    "uid": "home",
    "label": "Home",
    "path": "/",
    "icon": "Home",
    "hasAccess": true
  },
  {
    "id": "b2c3d4e5-f6g7-8901-bcde-f12345678901",
    "uid": "workflows",
    "label": "Workflows",
    "path": "/workflows",
    "icon": "Workflow",
    "hasAccess": true,
    "children": [
      {
        "id": "c3d4e5f6-g7h8-9012-cdef-123456789012",
        "uid": "workflows_create",
        "label": "Create New",
        "path": "/workflows/create",
        "icon": "PlusSquare",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "4e72e1aa-8c6d-4d2b-bd35-0df9a5df4d01",
    "uid": "copilot",
    "label": "Copilot",
    "path": "/portal/chatagent",
    "icon": "Bot",
    "hasAccess": true
  },
  {
    "id": "bfaf4b2c-3d90-4c76-bb0b-4d44eacdb7b8",
    "uid": "copilot_create",
    "label": "Create Chat Agent",
    "path": "/portal/createchatagent",
    "icon": "Plus",
    "hasAccess": true
  },
  {
    "id": "d918c2ef-0c74-46c7-b50d-dcf4d0d7c59d",
    "uid": "functions",
    "label": "Functions",
    "path": "/portal/agents",
    "icon": "FunctionSquare",
    "hasAccess": true
  },
  {
    "id": "2fae4f67-f4d2-4b90-9b77-2a89efdd9f11",
    "uid": "function_agent_studio",
    "label": "Agent Studio",
    "path": "/portal/agentStudio",
    "icon": "Bot",
    "hasAccess": true
  },
  {
    "id": "70b4dff6-7d13-43b0-a6d6-cba6b5b4a8ce",
    "uid": "analytics_hub",
    "label": "Analytics Hub",
    "path": "/portal/analytics-hub",
    "icon": "BarChart3",
    "hasAccess": true
  },
  {
    "id": "c8dfb1d4-74ef-46f2-8b55-c39d38dc0a65",
    "uid": "analytics_hub_designer",
    "label": "Designer",
    "path": "/portal/analytics-hub/designer",
    "icon": "PenTool",
    "hasAccess": true
  },
  {
    "id": "6f3a0f4c-20b7-4c2a-b4c1-7caaed2358b7",
    "uid": "Applications",
    "label": "Applications",
    "path": "/applications",
    "icon": "AppWindow",
    "hasAccess": true
  },
  {
    "id": "e8c4a1b2-7d3f-4a91-8e5c-2b6f9d0a4c17",
    "uid": "catalog",
    "label": "Catalog",
    "path": "/portal/catalog",
    "icon": "Library",
    "hasAccess": true
  },
  {
    "id": AI_MODELS_MODULE_ID,
    "uid": "ai_models",
    "label": "AI Models",
    "path": "/portal/ai-models",
    "icon": "BrainCircuit",
    "hasAccess": true,
    "children": [
      {
        "id": AI_MODELS_REGISTER_ID,
        "uid": "ai_models_register",
        "label": "Register",
        "path": "/portal/ai-models/register",
        "icon": "PlusSquare",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "d4e5f6g7-h8i9-0123-def1-234567890123",
    "uid": "agents",
    "label": "Agents",
    "path": "/agents",
    "icon": "Bot",
    "hasAccess": true,
    "children": [
      {
        "id": "e5f6g7h8-i9j0-1234-ef12-345678901234",
        "uid": "agent_studio",
        "label": "Agent Studio",
        "path": "/agents/studio",
        "icon": "LayoutTemplate",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "f6g7h8i9-j0k1-2345-f123-456789012345",
    "uid": "entities",
    "label": "Entities",
    "path": "/entities",
    "icon": "Database",
    "hasAccess": true,
    "children": [
      {
        "id": "g7h8i9j0-k1l2-3456-1234-567890123456",
        "uid": "entities_new",
        "label": "New Entity",
        "path": "/entities/new",
        "icon": "FilePlus",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "h8i9j0k1-l2m3-4567-2345-678901234567",
    "uid": "knowledge_workspace",
    "label": "Knowledge Workspace",
    "path": "/knowledge",
    "icon": "BookOpen",
    "hasAccess": true,
    "children": [
      {
        "id": "i9j0k1l2-m3n4-5678-3456-789012345678",
        "uid": "knowledge_add",
        "label": "Add New",
        "path": "/knowledge/add",
        "icon": "FilePlus2",
        "hasAccess": true
      },
      {
        "id": "j0k1l2m3-n4o5-6789-4567-890123456789",
        "uid": "knowledge_manage",
        "label": "Manage",
        "path": "/knowledge/manage",
        "icon": "Settings",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "k1l2m3n4-o5p6-7890-5678-901234567890",
    "uid": "llm_routing",
    "label": "LLM Routing",
    "path": "/llm-routing",
    "icon": "Brain",
    "hasAccess": true,
    "children": [
      {
        "id": "l2m3n4o5-p6q7-8901-6789-012345678901",
        "uid": "llm_add",
        "label": "Add New",
        "path": "/llm-routing/add",
        "icon": "FilePlus",
        "hasAccess": true
      },
      {
        "id": "m3n4o5p6-q7r8-9012-7890-123456789012",
        "uid": "llm_edit",
        "label": "Edit",
        "path": "/llm-routing/edit",
        "icon": "Edit3",
        "hasAccess": true
      },
      {
        "id": "n4o5p6q7-r8s9-0123-8901-234567890123",
        "uid": "llm_delete",
        "label": "Delete",
        "path": "/llm-routing/delete",
        "icon": "Trash2",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "o5p6q7r8-s9t0-1234-9012-345678901234",
    "uid": "data_vault",
    "label": "Data Vault",
    "path": "/data-vault",
    "icon": "Vault",
    "hasAccess": true,
    "children": [
      {
        "id": "p6q7r8s9-t0u1-2345-0123-456789012345",
        "uid": "data_add",
        "label": "Add New",
        "path": "/data-vault/add",
        "icon": "FilePlus",
        "hasAccess": true
      },
      {
        "id": "q7r8s9t0-u1v2-3456-1234-567890123456",
        "uid": "data_edit",
        "label": "Edit",
        "path": "/data-vault/edit",
        "icon": "Edit",
        "hasAccess": true
      },
      {
        "id": "r8s9t0u1-v2w3-4567-2345-678901234567",
        "uid": "data_delete",
        "label": "Delete",
        "path": "/data-vault/delete",
        "icon": "Trash",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "s9t0u1v2-w3x4-5678-3456-789012345678",
    "uid": "schedules",
    "label": "Schedules",
    "path": "/schedules",
    "icon": "CalendarClock",
    "hasAccess": true,
    "children": [
      {
        "id": "t0u1v2w3-x4y5-6789-4567-890123456789",
        "uid": "schedule_configure",
        "label": "Configure Schedule",
        "path": "/schedules/configure",
        "icon": "Settings2",
        "hasAccess": true
      },
      {
        "id": "u1v2w3x4-y5z6-7890-5678-901234567890",
        "uid": "schedule_logs",
        "label": "Logs",
        "path": "/schedules/logs",
        "icon": "ScrollText",
        "hasAccess": true
      },
      {
        "id": "v2w3x4y5-z6a7-8901-6789-012345678901",
        "uid": "schedule_trigger",
        "label": "Run/Trigger",
        "path": "/schedules/run",
        "icon": "PlayCircle",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "w3x4y5z6-a7b8-9012-7890-123456789012",
    "uid": "intent_orchestration",
    "label": "Intent Orchestration",
    "path": "/intents",
    "icon": "Zap",
    "hasAccess": true,
    "children": [
      {
        "id": "x4y5z6a7-b8c9-0123-8901-234567890123",
        "uid": "intent_new",
        "label": "New Model",
        "path": "/intents/new",
        "icon": "Sparkle",
        "hasAccess": true
      },
      {
        "id": "y5z6a7b8-c9d0-1234-9012-345678901234",
        "uid": "intent_edit",
        "label": "Edit",
        "path": "/intents/edit",
        "icon": "Edit3",
        "hasAccess": true
      },
      {
        "id": "z6a7b8c9-d0e1-2345-0123-456789012345",
        "uid": "intent_delete",
        "label": "Delete",
        "path": "/intents/delete",
        "icon": "Trash",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "a7b8c9d0-e1f2-3456-1234-567890123456",
    "uid": "deployments",
    "label": "Deployments",
    "path": "/deployments",
    "icon": "Rocket",
    "hasAccess": true,
    "children": [
      {
        "id": "b8c9d0e1-f2g3-4567-2345-678901234567",
        "uid": "deployment_new",
        "label": "New",
        "path": "/deployments/new",
        "icon": "Plus",
        "hasAccess": true
      },
      {
        "id": "c9d0e1f2-g3h4-5678-3456-789012345678",
        "uid": "deployment_test",
        "label": "Test",
        "path": "/deployments/test",
        "icon": "TestTube2",
        "hasAccess": true
      },
      {
        "id": "d0e1f2g3-h4i5-6789-4567-890123456789",
        "uid": "deployment_delete",
        "label": "Delete",
        "path": "/deployments/delete",
        "icon": "Trash2",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "e1f2g3h4-i5j6-7890-5678-901234567890",
    "uid": "connections",
    "label": "Connection & Keys",
    "path": "/connections",
    "icon": "KeyRound",
    "hasAccess": true,
    "children": [
      {
        "id": "f2g3h4i5-j6k7-8901-6789-012345678901",
        "uid": "connection_new",
        "label": "New",
        "path": "/connections/new",
        "icon": "PlusCircle",
        "hasAccess": true
      },
      {
        "id": "g3h4i5j6-k7l8-9012-7890-123456789012",
        "uid": "connection_edit",
        "label": "Edit",
        "path": "/connections/edit",
        "icon": "Edit",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "h4i5j6k7-l8m9-0123-8901-234567890123",
    "uid": "access_settings",
    "label": "Access Setting",
    "path": "/access",
    "icon": "ShieldCheck",
    "hasAccess": true,
    "children": [
      {
        "id": "i5j6k7l8-m9n0-1234-9012-345678901234",
        "uid": "access_users",
        "label": "User Management",
        "path": "/access/users",
        "icon": "Users2",
        "hasAccess": true
      },
      {
        "id": "j6k7l8m9-n0o1-2345-0123-456789012345",
        "uid": "access_roles",
        "label": "Role Configuration",
        "path": "/access/roles",
        "icon": "UserCog2",
        "hasAccess": true
      },
      {
        "id": "k7l8m9n0-o1p2-3456-1234-567890123456",
        "uid": "access_rights",
        "label": "Role Rights",
        "path": "/access/rights",
        "icon": "LockKeyhole",
        "hasAccess": true
      },
      {
        "id": "l8m9n0o1-p2q3-4567-2345-678901234567",
        "uid": "access_assign",
        "label": "Assign Users",
        "path": "/access/assign",
        "icon": "UserPlus",
        "hasAccess": true
      }
    ]
  },
  {
    "id": MCP_ACCESS_MANAGER_MODULE_ID,
    "uid": "mcp_access_manager",
    "label": "MCP Gateway",
    "path": GOVERNED_MCP_GATEWAY_PATHS.dashboard,
    "icon": "Network",
    "hasAccess": true,
    "children": [
      ...GOVERNED_MCP_GATEWAY_PAGES,
      {
        "id": MCP_RESOURCES_MODULE_ID,
        "uid": "mcp_resources",
        "label": "External MCPs",
        "path": "/portal/mcpresources",
        "icon": "Database",
        "hasAccess": true
      },
      {
        "id": "d4a5e6f7-8b9c-40d1-2e34-5f6a7b8c9d0e",
        "uid": "mcp_monitoring",
        "label": "Monitoring",
        "path": "/portal/mcplivemonitor",
        "icon": "Activity",
        "hasAccess": true
      },
      GOVERNED_MCP_GATEWAY_ACTIVITY_NODE,
    ]
  },
  {
    "id": "g1h2i3j4-k5l6-7890-abcd-ef12345678901",
    "uid": "ai_governance",
    "label": "AI Governance",
    "path": "/portal/ai-governance/policies",
    "icon": "Scale",
    "hasAccess": true,
    "children": [
      {
        "id": "g2h3i4j5-k6l7-8901-bcde-f12345678902",
        "uid": "ai_governance_policies",
        "label": "Policies",
        "path": "/portal/ai-governance/policies",
        "icon": "Shield",
        "hasAccess": true
      },
      {
        "id": "g3h4i5j6-k7l8-9012-cdef-123456789013",
        "uid": "ai_governance_groups",
        "label": "Policy Groups",
        "path": "/portal/ai-governance/groups",
        "icon": "Users",
        "hasAccess": true
      },
      {
        "id": "g4h5i6j7-k8l9-0123-def1-234567890124",
        "uid": "ai_governance_audit",
        "label": "Audit Logs",
        "path": "/portal/ai-governance/audit-logs",
        "icon": "FileText",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "m9n0o1p2-q3r4-5678-3456-789012345678",
    "uid": "system_settings",
    "label": "System Setting",
    "path": "/system",
    "icon": "Settings",
    "hasAccess": true
  },
  {
    "id": "n0o1p2q3-r4s5-6789-4567-890123456789",
    "uid": "my_account",
    "label": "My Account",
    "path": "/account",
    "icon": "UserCircle",
    "hasAccess": true
  },
  {
    "id": "o1p2q3r4-s5t6-7890-5678-901234567890",
    "uid": "logs",
    "label": "Logs",
    "path": "/logs",
    "icon": "ScrollText",
    "hasAccess": true
  },
  {
    "id": "p2q3r4s5-t6u7-8901-6789-012345678901",
    "uid": "reports",
    "label": "Reports",
    "path": "/reports",
    "icon": "BarChart3",
    "hasAccess": true
  },
  {
    "id": "q3r4s5t6-u7v8-9012-7890-123456789012",
    "uid": "chat",
    "label": "Chat",
    "path": "/chat",
    "icon": "MessageCircle",
    "hasAccess": true,
    "children": [
      {
        "id": "r4s5t6u7-v8w9-0123-8901-234567890123",
        "uid": "chat_reports",
        "label": "Custom Reports",
        "path": "/chat/reports",
        "icon": "FileBarChart",
        "hasAccess": true
      },
      {
        "id": "s5t6u7v8-w9x0-1234-9012-345678901234",
        "uid": "chat_triggers",
        "label": "Custom Triggers",
        "path": "/chat/triggers",
        "icon": "Zap",
        "hasAccess": true
      },
      {
        "id": "t6u7v8w9-x0y1-2345-0123-456789012345",
        "uid": "chat_dashboards",
        "label": "Dashboards",
        "path": "/chat/dashboards",
        "icon": "LayoutDashboard",
        "hasAccess": true
      },
      {
        "id": "u7v8w9x0-y1z2-3456-1234-567890123456",
        "uid": "chat_favorites",
        "label": "Favorites",
        "path": "/chat/favorites",
        "icon": "Star",
        "hasAccess": true
      },
      {
        "id": "v8w9x0y1-z2a3-4567-2345-678901234567",
        "uid": "chat_history",
        "label": "History",
        "path": "/chat/history",
        "icon": "History",
        "hasAccess": true
      }
    ]
  }
]
export const nonAdminRoutes = [
  {
    "id": MCP_ACCESS_MANAGER_MODULE_ID,
    "uid": "mcp_access_manager",
    "label": "MCP Gateway",
    "path": GOVERNED_MCP_GATEWAY_PATHS.dashboard,
    "icon": "Network",
    "hasAccess": true,
    "children": [GOVERNED_MCP_GATEWAY_NODE]
  },
  {
    "id": AI_MODELS_MODULE_ID,
    "uid": "ai_models",
    "label": "AI Models",
    "path": "/portal/ai-models",
    "icon": "BrainCircuit",
    "hasAccess": true,
    "children": [
      {
        "id": AI_MODELS_REGISTER_ID,
        "uid": "ai_models_register",
        "label": "Register",
        "path": "/portal/ai-models/register",
        "icon": "PlusSquare",
        "hasAccess": true
      }
    ]
  },
  {
    "id": "q3r4s5t6-u7v8-9012-7890-123456789012",
    "uid": "chat",
    "label": "Chat",
    "path": "/chat",
    "icon": "MessageCircle",
    "hasAccess": true,
    "children": [
      {
        "id": "r4s5t6u7-v8w9-0123-8901-234567890123",
        "uid": "chat_reports",
        "label": "Custom Reports",
        "path": "/chat/reports",
        "icon": "FileBarChart",
        "hasAccess": true
      },
      {
        "id": "s5t6u7v8-w9x0-1234-9012-345678901234",
        "uid": "chat_triggers",
        "label": "Custom Triggers",
        "path": "/chat/triggers",
        "icon": "Zap",
        "hasAccess": true
      },
      {
        "id": "t6u7v8w9-x0y1-2345-0123-456789012345",
        "uid": "chat_dashboards",
        "label": "Dashboards",
        "path": "/chat/dashboards",
        "icon": "LayoutDashboard",
        "hasAccess": true
      },
      {
        "id": "u7v8w9x0-y1z2-3456-1234-567890123456",
        "uid": "chat_favorites",
        "label": "Favorites",
        "path": "/chat/favorites",
        "icon": "Star",
        "hasAccess": true
      },
      {
        "id": "v8w9x0y1-z2a3-4567-2345-678901234567",
        "uid": "chat_history",
        "label": "History",
        "path": "/chat/history",
        "icon": "History",
        "hasAccess": true
      }
    ]
  }
]

